'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var array = require('./array-b2d24238.cjs');



exports.appendTo = array.appendTo;
exports.copy = array.copy;
exports.create = array.create;
exports.equalFlat = array.equalFlat;
exports.every = array.every;
exports.flatten = array.flatten;
exports.from = array.from;
exports.last = array.last;
exports.some = array.some;
//# sourceMappingURL=array.cjs.map
